/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ReactTooltip from 'react-tooltip'
import ModelFrame from 'components/ModelFrame'
import LoadingScreen from 'components/LoadingScreen'
import Button from 'components/Button'
import Input from 'components/Input'
import Modal from 'components/Modal'
import headrestVideo from 'img/adjustable_headrest.mp4'

import ConfirmationPage from 'components/ConfirmationPage'
import ReactHintFactory from 'react-hint'
import 'react-hint/css/index.css'
import { sendEmail } from 'services/email-service'
import {
  armrest,
  backrest,
  woodtrim,
  woodFinish,
  leather,
  diamondQuilting,
  cupholder,
  stitch,
  piping,
  layout,
  pin as pinHelper,
  steelLeg as steelLegHelper
} from 'helpers'
import { armrests, backrests, woodtrims, woodFinishes, leathers, cupholders, stitches, layouts_front, layouts_back, layouts_front_longue, pins, steelLegs } from 'mappers'
import { ExportTool, Container } from './Configurator.style'
import logoImage from '../../img/logomark.png'
import { gaTrackNext, gaTrackSubmit, getStepFromQuery, updateStepQuery } from './utils'
import Summary from 'components/Summary'
import ArPreview from 'components/ArPreview'
import Form from 'components/Form'
import { Mailer } from 'services/Mailer'
import {convertToUSD} from "../../helpers/currency";
import { Check } from 'components/Form/Check'
const ReactHint = ReactHintFactory(React)


// window.toast = toast

function handler(e) {
  e.stopPropagation()
  e.preventDefault()
}

class Configurator extends Component {
  constructor(props) {
    super(props)
    const {
      arm,
      seat,
      wood,
      finish,
      pin,
      leather,
      cupholder,
      stitch,
      diamond,
      longue,
      pipingMaterial,
      piping,
      headrest,
      layoutFront,
      layoutBack,
      steelLeg = null
    } = props

    this.state = {
      basePrice: 3990,
      pendingRequest: false,
      apiLoaded: false,
      step: getStepFromQuery() || 1,
      loaderIsHidden: false,
      showHint: true,
      isModalOpen: false,
      isRatio50: false,
      showConfirmationPage: false,
      screenshots: {
        inProcess: false,
        width: 500,
        height: 500,
        images: [],
      },
      invalidEmail: false,
      isPopupVisible: false,
      ar:{
        success: false,
        url: null,
        glb: null,
        usdz: null,
      },
      parts: {
        arm: arm || armrests[0],
        seat: seat || backrests[3],
        wood: wood || woodtrims[4],
        finish: finish || woodFinishes[2],
        pin: pin || pins[0],
        leather: leather || leathers[1][0],
        cupholder: cupholder || cupholders[0],
        steelLeg: steelLeg || steelLegs[0],
        stitch: piping ? false : stitch || false,
        diamond: diamond || false,
        longue: longue || false,
        pipingMaterial: pipingMaterial || leathers[0][5],
        piping: piping || false,
        headrest: headrest || false,
        layoutFront: layoutFront || layouts_front[5],
        layoutBack: layoutBack || false,
      },
      form: {
        companyTypes: {},
        additionalRequirements: {},
        pageLoadTime: performance.now(),
      },
      goToStep1: false,
      submitTime: 0
    }

    if (window.history.pushState) {
      var newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        this.generateQueryParams(this.state.parts)
      window.history.replaceState({ path: newurl }, '', newurl)
    }

    window.getJSONstring = this.getJSONstring;
    window.setupJSON = this.setupJSON;
  }

  setupJSON = () => {
    const parts = this.state.parts;
    const {leather, cupholder, steelLeg, stitch, pin, diamond, finish, piping, pipingMaterial, seat, wood, arm} = parts;
    const obj = {
      piping: {
        enabled: piping,
        colorName: pipingMaterial.colorName,
        hex: pipingMaterial.hex,
        leatherName: pipingMaterial.leatherName,
        // name: parts.pin.buttonName
      },
      pin:{
        name: pin.buttonName,
        textureName: pin.textureName,
      },
      leather: {
        hex: leather.hex,
        name: leather.leatherName },
      finish: {
        class: finish.class,
        name: finish.name },
      diamond: diamond,
      cupholder: {
        name: cupholder.name,
        hex: cupholder.hex },
      steelLeg: {
        name: steelLeg.name,
        hex: steelLeg.hex },
      woodTrim: {
        name: wood.name,
        hex: wood.hex,
        textureName: wood.textureName },
      armrest: {
        name: arm.buttonName,
        containsWood: arm.containsWood,
        node: arm.node
      },
      backrest: {
        name: seat.buttonName,
        node: seat.node
      }


    };

    return obj;

  }


  async fetchArData(){

    this.setState({
      pendingRequest: true,
      url: null,
      error: null,
      ar:{},
    });

    // const response = await fetch("https://elite.vps.ar-range.app/api/process.php", {
      const response = await fetch("https://devel.bigbanda.pl/ar-elite/api/process.php", {
      method: 'POST',
      body: this.getJSONstring(),
      redirect: 'follow'
    })
    .then(response => response.json())
    .catch(error =>{

      this.setState({
        pendingRequest: false
      });
    });
    var error = null;

    if(response['success']) {
      error = null;
    }else{
      error = response['message'];
    }

    this.setState({
      ar: response,
      pendingRequest: false,
      error: error,
      url: response['url']
    });
  }

  getJSONstring = () => {
    return JSON.stringify(this.setupJSON());
  }

  componentDidMount() {
    document.getElementById('configuratorWrapper').addEventListener('click', handler, true)

    setTimeout(() => this.setState({ goToStep1: true, step: 1 }), 3500)
  }

  componentDidUpdate(prevProps, prevState) {
    const { step, parts } = this.state
    if (JSON.stringify(parts) !== JSON.stringify(prevState.parts)) {
      if (window.history.pushState) {
        var newurl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname +
          this.generateQueryParams(parts)
        window.history.replaceState({ path: newurl }, '', newurl)
      }
    }
    if (step !== prevState.step) {
      this.setState({
        showHint: true,
      })
      if (step === 3 || (step === 4 && window.api2)) {
        leather.changeColor(parts.leather.overwriteChannels, parts.leather.hex, window.api2, false, parts.diamond)
        cupholder.changeCupholder(parts.cupholder.overwriteChannels, parts.cupholder.hex, window.api2)
        steelLegHelper.changeSteelLeg(parts.steelLeg.overwriteChannels, parts.steelLeg.hex, window.api2)
        if(window.api){

          window.api.gotoAnnotation(window.api._getAnnotationByName('step3').index)
        }
      }
      if (step === 1 || step === 2) {
        if(window.api){

          window.api.gotoAnnotation(window.api._getAnnotationByName('default').index)
        }
      }
      if(step === 4){
        this.fetchArData();

      }
    }
  }

  generateQueryParams = (parts, withExport = true) => {
    const {
      arm,
      seat,
      wood,
      finish,
      pin,
      leather,
      cupholder,
      stitch,
      diamond,
      longue,
      pipingMaterial,
      piping,
      layoutFront,
      layoutBack,
      steelLeg,
      headrest,
    } = parts
    const params = {}
    const parameters = new URLSearchParams(window.location.search)

    if (parameters.has('export') && withExport) {
      params['export'] = true
    }

    params['home_theater_seat_armrest'] = arm.buttonName
    params['home_theater_chair_backrest'] = seat.buttonName
    params['wood_trim'] = wood.name
    params['wood_finish'] = finish.class
    params['metal_finish'] = pin.buttonName
    params['leather_color'] = leather.colorName
    params['leather_material'] = leather.leatherName
    params['cupholder'] = cupholder.name
    params['steelLeg'] = steelLeg.name
    if (stitch) {
      params['stitch_color'] = stitch.name
    }
    if (diamond) {
      params['diamond'] = '1'
    }
    if (longue) {
      params['longue'] = '1'
    }
    if (headrest) {
      params['headrest'] = '1'
    }
    if (piping) {
      params['piping_color'] = pipingMaterial.colorName
      params['piping_material'] = pipingMaterial.leatherName
    }
    params['layout_front'] = layoutFront.buttonName
    params['layout_back'] = layoutBack && layoutBack.buttonName

    params['utm_source'] = parameters.get('utm_source');
    params['utm_medium'] = parameters.get('utm_medium');
    params['utm_campaign'] = parameters.get('utm_campaign');
    params['utm_id'] = parameters.get('utm_id');
    params['utm_term'] = parameters.get('utm_term');
    params['utm_content'] = parameters.get('utm_content');
    params['sketchfabModelId'] = parameters.get('sketchfabModelId');

    return `?${Object.keys(params).filter(param => !!params[param])
      .map((param) => `${param}=${params[param]}`)
      .join('&')}`
  }

  onFrameLoaded = () => {
    const { parts } = this.state

    this.makeInitialConfiguration(parts)
    setTimeout(
      () =>
        this.setState({ apiLoaded: true }, () =>{

          document.getElementById('configuratorWrapper').removeEventListener('click', handler, true)
          steelLegHelper.changeSteelLeg(parts.steelLeg.overwriteChannels, parts.steelLeg.hex, window.api2)
        }

        ),
      700
    )
  }

  on2ndFrameLoaded = (api2) => {
    const { parts } = this.state
    const { layoutFront, layoutBack } = parts

    this.setState({ apiLoaded: true }, () => {
      // layout.showLayouts(layoutBack ? [layoutFront.node + 1, layoutBack.node + 2] : [layoutFront.node + 1])
      layout.showLayouts(layoutBack ? [layoutFront.node, layoutBack.node] : [layoutFront.node])
      leather.changeColor(parts.leather.overwriteChannels, parts.leather.hex, api2, false, parts.diamond)
      cupholder.changeCupholder(parts.cupholder.overwriteChannels, parts.cupholder.hex, api2)
      steelLegHelper.changeSteelLeg(parts.steelLeg.overwriteChannels, parts.steelLeg.hex, api2)
    })
  }

  makeInitialConfiguration = (parts) => {
    const {
      arm,
      seat,
      wood: woodTexture,
      finish,
      pin: chosenPin,
      leather: chosenLeather,
      pipingMaterial,
      piping: showPiping,
      diamond: showDiamond,
      stitch: chosenStitch,
      steelLeg
    } = parts
    this.changeLayout()
    woodtrim.changeWoodtrimTexture(woodTexture.overwriteChannels, woodTexture.hex)
    armrest.showOneArm(arm.node)
    backrest.showOneSeat(seat.node)
    woodFinish.changeGlossiness(finish.overwriteChannels)
    pinHelper.changePinTexture(chosenPin.overwriteChannels, chosenPin.textureName)
    leather.changeColor(chosenLeather.overwriteChannels, chosenLeather.hex, window.api, true, parts.diamond)

    if (showPiping) {
      piping.show()
      this.changePiping(pipingMaterial)
    }
    if (showDiamond) {
      diamondQuilting.show()
    }
    if (chosenStitch) {
      stitch.changeStitchesColor(chosenStitch.overwriteChannels, chosenStitch.hex)
    } else {
      stitch.changeStitchesColor(stitches[0].overwriteChannels, chosenLeather.hex)
    }
  }

  changeLayout = (newLayout, row) => {
    let { parts } = this.state

    const layoutFront = row === 1 ? newLayout : parts.layoutFront
    const layoutBack = row === 2 ? newLayout : parts.layoutBack
    const isLongue = parts.longue

    // layout.showLayouts(!!layoutBack ? [layoutFront.node + 1, layoutBack.node + 2] : [layoutFront.node + 1]).then(() => {
    layout.showLayouts(!!layoutBack ? [layoutFront.node , layoutBack.node ] : [layoutFront.node ]).then(() => {
      parts = { ...parts, layoutFront, layoutBack }

      this.setState({ parts })
    })
  }

  changeBackrest = (seat) => {
    const { parts: prevParts } = this.state
    const parts = { ...prevParts, seat }

    this.setState({ parts }, () => {
      // diamondQuilting.hide()
      backrest.showOneSeat(seat.node);
      this.updatePipping();
    })
  }

  changeArmrest = (arm) => {
    const { parts: prevParts } = this.state
    const parts = { ...prevParts, arm }

    this.setState({ parts }, () => {
      armrest.showOneArm(arm.node)
      this.updatePipping();
    })
  }

  changeWoodtrim = (wood) => {
    const { parts: prevParts } = this.state
    const parts = { ...prevParts, wood }

    this.setState({ parts }, () => {
      woodtrim.changeWoodtrimTexture(wood.overwriteChannels, wood.hex)
    })
  }

  changeWoodFinish = (finish = this.state.parts.finish) => {
    const { parts: prevParts } = this.state
    const parts = { ...prevParts, finish }

    this.setState({ parts }, () => {
      woodFinish.changeGlossiness(finish.overwriteChannels)
    })
  }



  changeSteelLeg = (chosenLeg) => {
    const { parts: prevParts } = this.state
    const parts = { ...prevParts, steelLeg: chosenLeg }

    this.setState({ parts }, () => {
      steelLegHelper.changeSteelLeg(chosenLeg.overwriteChannels, chosenLeg.hex)
      // window.api.gotoAnnotation(window.api._getAnnotationByName('cupholders').index)
    })
  }

  changeLeather = (chosenLeather) => {
    const { parts: prevParts } = this.state
    const parts = { ...prevParts, leather: chosenLeather }
    const defaultStitch = !parts.stitch && { ...stitches[0], hex: chosenLeather.hex }

    this.setState({ parts }, () => {
      leather.changeColor(chosenLeather.overwriteChannels, chosenLeather.hex, window.api, true, parts.diamond)
      if (defaultStitch) {
        stitch.changeStitchesColor(defaultStitch.overwriteChannels, defaultStitch.hex)
      }
    })
  }

  changeCupholder = (chosenCupholder) => {
    const { parts: prevParts } = this.state
    const parts = { ...prevParts, cupholder: chosenCupholder }

    this.setState({ parts }, () => {
      cupholder.changeCupholder(chosenCupholder.overwriteChannels, chosenCupholder.hex)
      window.api.gotoAnnotation(window.api._getAnnotationByName('cupholders').index)
    })
  }

  toggleDiamond = () => {
    const { parts } = this.state
    const newState = !parts.diamond
    this.setState(
      {
        parts: {
          ...parts,
          diamond: !!newState,
        },
      },
      () => {
        if (newState) {
          diamondQuilting.show()
        } else {
          diamondQuilting.hide()
        }
      }
    )
  }

  toggleLongue = () => {
    const { parts } = this.state
    const newState = !parts.longue

    const frontLayout = !newState ? layouts_front[5] : layouts_front_longue[5];



    this.setState(
      {
        parts: {
          ...parts,
          longue: !!newState,
          layoutFront: frontLayout,
          // layoutBack: false,
        },
      },
      () => {
        // layout.hideBackRow();
        const nodes = [frontLayout.node];
        if(parts.layoutBack){
          nodes.push(parts.layoutBack.node);
        }
        layout.showLayouts(nodes);
        // if (!parts.layoutBack) {
        // }
      }
    )
  }

  togglePiping = () => {
    const { parts } = this.state
    const newState = !parts.piping
    this.setState(
      {
        parts: {
          ...parts,
          piping: !!newState,
        },
      },
      () => {
        if (newState) {
          piping.show()
          this.changePiping(parts.pipingMaterial)
          // hide stitch
          if (!!parts.stitch) this.toggleStitch(true)
        } else {
          piping.hide()
        }
      }
    )
  }

  toggleHeadrest = () => {
    const { parts } = this.state
    const newState = !parts.headrest
    this.setState(
        {
          parts: {
            ...parts,
            headrest: !!newState,
          },
        },
        () => {
        }
    )
  }

  toggleStitch = () => {
    const { parts } = this.state
    const newState = !parts.stitch
    if (newState) {
      this.changeStitch(stitches[0])
    } else {
      this.setState({
        parts: {
          ...parts,
          stitch: null,
        },
      })
      stitch.changeStitchesColor(stitches[0].overwriteChannels, parts.leather.hex)
    }
  }

  changeStitch = (chosenStitch) => {
    const { parts: prevParts } = this.state
    const parts = { ...prevParts, stitch: chosenStitch }

    this.setState({ parts }, () => {
      stitch.changeStitchesColor(chosenStitch.overwriteChannels, chosenStitch.hex)
      window.api.gotoAnnotation(window.api._getAnnotationByName('threads').index)
      // hide piping
      if (!!parts.piping) this.togglePiping()
    })
  }

  toggleBackRow = () => {
    const { parts } = this.state
    const newState = !parts.layoutBack
    this.setState(
      {
        parts: {
          ...parts,
          layoutBack: !!newState ? layouts_back[4] : false,
        },
      },
      () => {
        if (newState) {
          layout.showBackRow(layouts_back[4].node)
        } else {
          layout.hideBackRow()
        }
      }
    )
  }

  changePiping = (chosenPiping) => {
    const { parts: prevParts } = this.state
    const parts = { ...prevParts, pipingMaterial: chosenPiping }

    this.setState({ parts }, () => {
      piping.changeColor(chosenPiping.overwriteChannels, chosenPiping.hex)
    })
  }

  changePin = (chosenPin) => {
    const { parts: prevParts } = this.state
    const parts = { ...prevParts, pin: chosenPin }

    this.setState({ parts }, () => {
      pinHelper.changePinTexture(chosenPin.overwriteChannels, chosenPin.textureName)
    })
  }

  getProperties = () => {
    const { parts } = this.state
    const {
      arm,
      seat,
      wood,
      finish,
      leather,
      cupholder,
      stitch,
      diamond,
      pipingMaterial,
      headrest,
      piping,
      layoutFront,
      layoutBack,
      pin,
    } = parts
    return {
      model: arm.buttonName + seat.buttonName,
      // price_per_seating_position: convertToUSD(this.getTotalPrice()) + ' MSRP',
      material: leather.leatherName,
      color: leather.colorName,
      stitching: stitch ? stitch.name : null,
      piping: piping ? `${pipingMaterial.colorName} (${pipingMaterial.leatherName})` : null,
      headrest: (this.isHeadrestPossible() && headrest) ? "Yes" : null,
      wood_trim: arm.containsWood ? wood.name : null,
      wood_finish: arm.containsWood ? finish.name : null,
      metal_finish: arm && arm.buttonName === 'L' ? pin && pin.buttonName : null,
      diamond_quilting: !['seat_2', 'seat_5', 'seat_8', 'seat_6'].includes(seat.node) ? (!!diamond ? 'Yes' : 'No') : null,
      cupholder: cupholder.name,
      foam_firmness: null,
      front_row_layout: layoutFront.buttonName,
      back_row_layout: layoutBack && layoutBack.buttonName,
    }
  }

  openPopup = () => {
    this.setState({ isPopupVisible: true })
  }

  closePopup = ( ) => {
    this.setState({ isPopupVisible: false })

  }
  updatePipping = () => {
    const { parts } = this.state
    const { piping } = parts
    if(this.isPippingPossible() === false){
      if(piping){
        this.togglePiping()
      }
    }
  }
  isPippingPossible = () => {
    const { parts } = this.state
    const { seat, arm } = parts

    if(arm && arm.buttonName === 'L'){
      return false;
    }

    if(seat && seat.buttonName === '2'){
      return false;
    }

    return true;
  }

  isHeadrestPossible = () => {
    const { parts } = this.state
    const { seat, arm } = parts

    if(seat && seat.buttonName === '1'){
      return true;
    }

    return false;
  }

  getModelProperties = () => {
    const { parts } = this.state
    const {
      arm,
      seat,
      wood,
      finish,
      leather,
      cupholder,
      steelLeg,
      diamond,
      pipingMaterial,
      headrest,
      piping,
      longue,
      pin,
    } = parts
    return (
        <div>
          <div>{leather.leatherName} - {leather.colorName}</div>
          {arm.containsWood && <>
            <div>Wood Trim - {wood.name}</div>
            <div>Wood Finish - {finish.name}</div>
          </>
          }
          {
              arm && arm.buttonName === 'B' && steelLeg &&
              <div>
                Metal Finish - {steelLeg.name}
              </div>
          }{
            arm && arm.buttonName === 'L' && pin &&
            <div>
              Metal Finish - {pin.buttonName}
            </div>
        }
          <div>Cupholder - {cupholder.name}</div>
          {!['seat_2', 'seat_5', 'seat_8', 'seat_6'].includes(seat.node) && !!diamond &&
              <div>
                Diamond Quilting
              </div>
          }
          {piping &&
              <div>
                Piping - {`${pipingMaterial.colorName} (${pipingMaterial.leatherName})`}
              </div>
          }
          {this.isHeadrestPossible() && headrest &&
              <div>
                Headrest
              </div>
          }
          {longue &&
              <div>
                Chaise Extension
              </div>
          }
        </div>
    )
  }

  getTotalPrice = () => {
    const parts = this.state.parts
    let price = this.state.basePrice
    price += parts.arm.price || 0
    price += parts.seat.price || 0
    price += parts.leather.leatherPrice || 0
    price += parts.piping ? 400 : 0
    // price += parts.longue ? 750 : 0
    price += (this.isHeadrestPossible() && parts.headrest) ? 500 : 0
    price += (!['seat_2', 'seat_5', 'seat_8', 'seat_6'].includes(parts.seat.node) && !!parts.diamond) ? 400 : 0
    return price;
  }

  getFeaturesText() {
    let text = (<div>
      - 20 Year Warranty <br/>
      - Custom Made in Canada <br/>
      - Power Recline <br/>
        {this.state.parts.arm.containsWood && <>
          - Hand Picked, Real Wood Trim <br/>
        </>}
      - Premium Seating Foam <br/>
      - Industrial Strength Mechanism <br/>
      - Engineered for Public <br/>&nbsp;&nbsp;Commercial Cinemas
    </div>
  );
    return text

  }
  getPanels = (stepN, side, props={}) => {
    const { parts, apiLoaded, step, emailIsSending, goToStep1 } = this.state
    const panels = {
      1: {
        left: (
          <div className={'leftPanel panel' + ((apiLoaded || goToStep1) && step === 1 ? ' ' : ' hidden') + ` ${props['className']}`} id="leathers">
            <div className="leftPanelContainer panelContainer leatherPanel">
              {leathers.map((leather, i) => {
                var tooltipProps = { [`data-custom-${i}`]: "1" };
                return <div className="group leatherColorsGroup">
                  <div className="title-row">
                    <div className="title">
                      {leather[0].leatherName}
                      <a className="tooltipTrigger"
                        data-rh
                        data-rh-at="bottom"
                        {...tooltipProps}
                      >
                        ⓘ
                      </a>
                      <ReactHint
                        autoPosition={false}
                        position={'bottom'}
                        events={{ click: true }}
                        attribute={`data-custom-${i}`}
                        onRenderContent={(target) => {
                          if (i === 0) {
                            return (<div className='react-hint__content'>
                              <div className="react-hint__content-flex">
                                <div className="react-hint__content-img"
                                  style={{
                                    backgroundImage: `url(${leather[0].sampleImageUrl})`,
                                  }}
                                />
                                <div className="react-hint__content-text">
                                  <div className="react-hint__title">
                                    {leather[0].leatherName}
                                  </div>
                                  {leather[0].tooltip}

                                </div>
                              </div>
                            </div>);
                          } else {
                            return (<div className='react-hint__content'>
                              <div className="react-hint__content-flex">
                                <div className="react-hint__content-img"
                                  style={{
                                    backgroundImage: `url(${leather[1].sampleImageUrl})`,
                                  }}
                                />
                                <div className="react-hint__content-text">
                                  <div className="react-hint__title">
                                    {leather[1].leatherName}
                                  </div>
                                  {leather[1].tooltip}

                                </div>
                              </div>
                            </div>);
                          }

                        }}
                      />

                    </div>
                    <div className="title-price">
                      {/*{(leather[0].leatherPrice?"+":"") + convertToUSD(leather[0].leatherPrice)}*/}
                    </div>
                  </div>
                  <div className="textNote">Custom colors available upon request</div>
                  <div className="buttonsWrapper">
                    <div className="scrollWrapper">
                      {leather.map((color) => (
                        <a key={color.colorName}
                          data-tip={color.colorName}
                          className={`button ${color.colorName === parts.leather.colorName &&
                            color.leatherName === parts.leather.leatherName
                            ? 'active'
                            : ''
                            }`}
                          onClick={() => this.changeLeather(color)}
                        >
                          <span
                            className="image"
                            style={{
                              backgroundColor: color.hex,
                            }}
                          >
                            <Check />
                          </span>
                          {/* for mobile leave this option */}
                          <div className="leatherColorName name onlyMobile">{color.colorName}</div>
                        </a>
                      ))}
                    </div>
                  </div>
                </div>
              })}

            </div>
          </div>
        ),
        right: (
          <div className={'rightPanel panel' + ((apiLoaded || goToStep1) && step === 1 ? ' ' : ' hidden')}>
            <div className="rightPanelContainer panelContainer">
              {/* <div className="group summaryGroup">
                <Summary />
              </div> */}
              <div className="group backrestGroup">
                <div className="title">
                  Choose Your Backrest
                  <div className="textNote">
                    All designs Patent Protected by Elite HTS
                  </div>
                </div>
                <div className="buttonsWrapper">
                  <div className="scrollWrapper">
                    {backrests.map((seat, i) => (
                      <div key={i}
                        className={`button ${seat.node === parts.seat.node ? 'active' : ''}`}
                        onClick={() => this.changeBackrest(seat)}
                      >
                        {seat.mostPopular &&
                            <div className='mostPopularBadge'>Most Popular</div>
                        }
                        <div
                          className="image"
                          style={{
                            backgroundImage: `url(${seat.buttonImage})`,
                          }}
                        />
                        <div className="backrestName name">#{seat.buttonName}</div>
                        {/*<div className="button-price">{(seat.price?"+":"")+ convertToUSD(seat.price)}</div>*/}
                      </div>
                    ))}
                  </div>
                </div>
              </div>


              {/* <div className="horizontalSplit" /> */}
              <div className="group armrestGroup">
                <div className="title">
                  Choose Your Arm
                  <div className="textNote" >
                    All designs Patent Protected by Elite HTS
                  </div>
                </div>
                <div className="buttonsWrapper">
                  <div className="scrollWrapper">
                    {armrests.map((arm) => (
                        <div
                            className={`button ${arm.node === parts.arm.node ? 'active' : ''}`}
                            onClick={() => this.changeArmrest(arm)}
                        >
                          {arm.mostPopular &&
                              <div className='mostPopularBadge'>Most Popular</div>
                          }
                          <div className="image" style={{backgroundImage: `url(${arm.buttonImage})`}}/>
                          <div className="armrestName name">{arm.buttonName}</div>
                          {/*<div className="button-price">{(arm.price ? "+" : "") + convertToUSD(arm.price)}</div>*/}

                        </div>
                    ))}
                    <div className='button' style={{visibility: 'hidden'}}></div>
                  </div>
                </div>
              </div>

              {/* steel leg selection / for armrest type B */}

            <div className={`group cupholdersGroup ${(parts.arm.buttonName === 'B' ? '' : ' disabled')}`}>
              <div className="title">Choose Your Metal Finish</div>
                <div className="buttonsWrapper">
                  <div className="scrollWrapper">
                    {steelLegs.map((finish) => (
                      <div
                        className={`cupholderButton button ${finish.name === parts.steelLeg.name ? 'active' : ''}`}
                        onClick={() => this.changeSteelLeg(finish)}
                      >
                        <div className="cupholderFinish name">{finish.name}</div>
                        <div
                          className="cupholderImage"
                          style={{
                            backgroundImage: `url(${finish.buttonImg})`,
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className={'group woodFinishGroup' + (parts.arm.containsWood ? '' : ' disabled')}>
                <div className="title">Choose Your Wood Finish</div>
                <div className="buttonsWrapper">
                  <div className="scrollWrapper">
                    {woodFinishes.map((finish) => (
                      <div
                        className={`button ${finish.name === parts.finish.name ? 'active' : ''}`}
                        style={{
                          backgroundImage: `url(${finish.buttonImage}), url(${finish.woodImage})`,
                        }}
                        onClick={() => this.changeWoodFinish(finish)}
                      >
                        <div className={`woodtrimName name`}>{finish.name}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className={'group woodtrimGroup' + (parts.arm.containsWood ? '' : ' disabled')}>
                <div className="title">Choose Your Woodtrim</div>
                <div className="buttonsWrapper">
                  <div className="scrollWrapper">
                    {woodtrims.map((wood) => (
                      <div
                        className={`button ${wood.name === parts.wood.name ? 'active' : ''}`}
                        onClick={() => this.changeWoodtrim(wood)}
                      >
                        <div
                          className="image"
                          style={{
                            backgroundColor: wood.hex,
                            backgroundImage: `url(${wood.url})`,
                          }}
                        />
                        <div className="woodtrimName name">{wood.name}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className={'group pinGroup' + (parts.arm.buttonName === 'L' ? '' : ' disabled')}>
                <div className="title">Choose Your Metal Finish</div>
                <div className="buttonsWrapper">
                  <div className="scrollWrapper">
                    {pins.map((pin) => (
                      <div
                        className={`button ${parts.pin && pin.buttonName === parts.pin.buttonName ? 'active' : ''}`}
                        onClick={() => this.changePin(pin)}
                      >
                        <div
                          className="image"
                          style={{
                            backgroundImage: `url(${pin.buttonImage})`,
                          }}
                        />
                        <div className="woodtrimName name">{pin.buttonName}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ),
      },
      2: {
        left: (
          <div className={'leftPanel panel' + ((apiLoaded || goToStep1) && step === 2 ? ' ' : ' hidden')}>
            <div className="leftPanelContainer panelContainer">

            <div className="group cupholdersGroup">
              <div className="title">Choose Your Cupholder Finish</div>
                <div className="buttonsWrapper">
                  <div className="scrollWrapper">
                    {cupholders.map((finish) => (
                      <div
                        className={`cupholderButton button ${finish.name === parts.cupholder.name ? 'active' : ''}`}
                        onClick={() => this.changeCupholder(finish)}
                      >
                        <div className="cupholderFinish name">{finish.name}</div>
                        <div
                          className="cupholderImage"
                          style={{
                            backgroundImage: `url(${finish.buttonImg})`,
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              {/* <div className="group stitchColorsGroup">
                <label className="textCheckbox">
                  <input
                    type="checkbox"
                    id="cbx5"
                    style={{ display: 'none' }}
                    checked={!!parts.stitch && !!parts.stitch.name}
                    onChange={this.toggleStitch}
                  />
                  <label htmlFor="cbx5" className="check">
                    <svg width="18px" height="18px" viewBox="0 0 18 18">
                      <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z" />
                      <polyline points="1 9 7 14 15 4" />
                    </svg>
                  </label>
                  <div className="title">Contrast Stitching</div>
                </label>

                <div className="textNote" style={{ textAlign: 'center' }}>
                  Custom colors available upon request
                </div>
                <div className={'buttonsWrapper' + (!!parts.stitch ? '' : ' disabled')}>
                  <div className="scrollWrapper">
                    {stitches.map((stitch) => (
                      <div
                        className={`stitchButton button ${
                          parts.stitch && stitch.name === parts.stitch.name ? 'active' : ''
                        }`}
                        onClick={() => this.changeStitch(stitch)}
                      >
                        <div className="stitchColor name">{stitch.name}</div>
                        <div
                          className="stitchImage"
                          style={{
                            color: stitch.hex,
                            backgroundColor: stitch.hex,
                            backgroundImage: `url(${stitch.buttonImg})`,
                          }}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              </div> */}
            </div>
            <div className="group checkboxesGroup">
              {!['seat_2', 'seat_5', 'seat_8', 'seat_6'].includes(parts.seat.node) && (
                <div className="diamondGroup">
                  <label className="title">
                    <input
                      type="checkbox"
                      id="cbx"
                      style={{ display: 'none' }}
                      checked={parts.diamond}
                      onChange={this.toggleDiamond}
                    />
                    <label htmlFor="cbx" className="check">
                      <svg width="18px" height="18px" viewBox="0 0 18 18">
                        <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z" />
                        <polyline points="1 9 7 14 15 4" />
                      </svg>
                    </label>
                    {!parts.diamond ? 'Add ':''}Diamond Quilting
                  </label>

                  <div className={`buttonsWrapper ${parts.diamond?'active':''}`} onClick={this.toggleDiamond}><div className="inner"></div></div>

                </div>
              )}
            </div>
            {/* chaise style */}
            <div className="group">

                <div className="longueGroup">
                  <label className="title">
                    <input
                      type="checkbox"
                      id="cbx3"
                      style={{ display: 'none' }}
                      checked={parts.longue}
                      onChange={this.toggleLongue}
                    />
                    <label htmlFor="cbx3" className="check">
                      <svg width="18px" height="18px" viewBox="0 0 18 18">
                        <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z" />
                        <polyline points="1 9 7 14 15 4" />
                      </svg>
                    </label>
                    <span>
                        In your final seating layout, do you prefer some seats
    to include chaise style extensions? <br/>
                      <span className='regular'>(by not selecting
    this option, all seats will be recliners) </span>
                      <br/>
                      {/*<span style={{marginTop: '0.3rem'}}>*/}
                      {/*+$750 per extension (calculated on final layout quote)*/}
                      {/*</span>*/}
                    </span>
                  </label>

                  <div className={`buttonsWrapper ${parts.longue?'active':''}`} onClick={this.toggleLongue}><div className="inner" style={{
                    backgroundImage: `url(${require('../../img/longue.png')})`
                  }}></div></div>

                </div>

            </div>
          </div>
        ),
        right: (
          <div className={'rightPanel panel' + ((apiLoaded || goToStep1) && step === 2 ? ' ' : ' hidden')}>
            <div className="rightPanelContainer panelContainer">

              {
                  this.isHeadrestPossible() && (
                      <div className="pipingGroup" style={{ marginBottom: 20}}>
                        <label className="title">
                          <input
                              type="checkbox"
                              id="djs_headrest"
                              style={{display: 'none'}}
                              checked={!!parts.headrest}
                              onChange={this.toggleHeadrest}
                          />
                          <label htmlFor="djs_headrest" className="check">
                            <svg width="18px" height="18px" viewBox="0 0 18 18">
                              <path
                                  d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"/>
                              <polyline points="1 9 7 14 15 4"/>
                            </svg>
                          </label>
                          {!parts.headrest ? 'Add ' : ''} Motorized Adjustable Headrest
                        </label>
                        <div className={`buttonsWrapper ${parts.headrest ? 'active' : ''}`} onClick={this.toggleHeadrest}>
                          <video muted loop autoPlay playsInline style={{width: '100%', display: "block"}} src={headrestVideo}></video>
                        </div>
                       </div>
                  )}

              {
                  this.isPippingPossible() && (

                      <div className="pipingGroup">
                      <label className="title">
                    <input
                        type="checkbox"
                        id="ppcbx"
                        style={{display: 'none'}}
                        checked={!!parts.piping}
                        onChange={this.togglePiping}
                    />
                    <label htmlFor="ppcbx" className="check">
                      <svg width="18px" height="18px" viewBox="0 0 18 18">
                        <path
                            d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z"/>
                        <polyline points="1 9 7 14 15 4"/>
                      </svg>
                    </label>
                    {!parts.piping ? 'Add ' : ''}Piping
                    </label>
                  {!parts.piping && (
                      <div className={`buttonsWrapper ${parts.piping?'active':''}`} onClick={this.togglePiping}><div className="inner"></div></div>
                      )}
                </div>
              )}
              <div className="group pipingColorGroup">


                <div style={{
                  display: parts.piping ? 'block':'none',
                }} className={'colorsWrapper' + (parts.piping ? '' : ' disabled')}>
                  {leathers.map((leather, i) => {
                    const tooltipTriggerProps = {

                      [`data-custom${i}`]: leather[i].tooltip,
                      [`data-custom${i}-at`]:"bottom"
                    };
                    return (
                    <div className="group leatherColorsGroup">
                      <div className="title">
                        {/* <div
                          className="leatherSampleImg"
                          style={{
                            backgroundImage: `url(${leather[0].sampleImageUrl})`,
                          }}
                        /> */}
                        {leather[0].leatherName}
                        <a
                          className="tooltipTrigger"
                          {...tooltipTriggerProps }
                        >
                          ⓘ
                        </a>

                        <ReactHint attribute={`data-custom${i}`} events={{ click: true }} autoPosition={false} onRenderContent={(target) => {
                            return (<div className='react-hint__content'>
                              <div className="react-hint__content-flex">
                                <div className="react-hint__content-img"
                                  style={{
                                    backgroundImage: `url(${leather[0].sampleImageUrl})`,
                                  }}
                                >
                                  <Check />
                                </div>
                                <div className="react-hint__content-text">
                                  <div className="react-hint__title">
                                    {leather[0].leatherName}
                                  </div>
                                  {leather[0].tooltip}

                                </div>
                              </div>
                            </div>);


                        }} />
                        <div className="textNote">Custom colors available upon request</div>
                      </div>
                      <div className="buttonsWrapper">
                        <div className="scrollWrapper">
                          {leather.map((color) => (
                            <a
                              data-tip={color.colorName}
                              className={`button ${
                                color.colorName === parts.pipingMaterial.colorName &&
                                color.leatherName === parts.pipingMaterial.leatherName
                                  ? 'active'
                                  : ''
                              }`}
                              onClick={() => this.changePiping(color)}
                            >
                              <span
                                className="image"
                                style={{
                                  backgroundColor: color.hex,
                                }}
                              >
                                <Check />
                              </span>
                              {/* for mobile leave this option */}
                              <div className="leatherColorName name onlyMobile">{color.colorName}</div>
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}
                  )}
                </div>
              </div>
            </div>
          </div>
        ),
      },
      3: {
        left: (
          <div className={'leftPanel panel' + ((apiLoaded || goToStep1) && step === 3 ? ' ' : ' hidden')}>
                        <div className="group layoutsGroup">
              <div className="title">Choose Front Row Layout</div>
              <div className="subtitle">Custom Layouts Available Upon Request</div>
              <div className="buttonsWrapper">
                <div className="inner" />

                <div className="scrollWrapper">
                  {(parts.longue ? layouts_front_longue : layouts_front).map((layout) => (
                    <div
                      className={`button ${layout.node === parts.layoutFront.node ? 'active' : ''}`}
                      onClick={() => this.changeLayout(layout, 1)}
                    >
                      <div
                        className="image"
                        style={{
                          backgroundImage: `url(${layout.buttonImage})`,
                        }}
                      />
                      <div className="layoutName name">
                        <b>{layout.buttonName}</b> <br />
                        <span style={{ fontStyle: 'italic' }}>{layout.width}</span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

          </div>
        ),
        right: (
          <div className={'rightPanel panel' + ((apiLoaded || goToStep1) && step === 3 ? ' ' : ' hidden')}>

          <div className="group layoutsGroup">
          <div className="secondRow">

            <label className="textNote textCheckbox">
              <input
                type="checkbox"
                id="cbx_sr"
                style={{ display: 'none' }}
                checked={!!parts.layoutBack}
                onChange={this.toggleBackRow}
              />
              <label htmlFor="cbx_sr" className="check">
                <svg width="18px" height="18px" viewBox="0 0 18 18">
                  <path d="M1,9 L1,3.5 C1,2 2,1 3.5,1 L14.5,1 C16,1 17,2 17,3.5 L17,14.5 C17,16 16,17 14.5,17 L3.5,17 C2,17 1,16 1,14.5 L1,9 Z" />
                  <polyline points="1 9 7 14 15 4" />
                </svg>
              </label>
              <div className="title">{!parts.layoutBack?`Add Second Row`:`Remove Second Row`}</div>
              {/* <div className="title">{!parts.layoutBack?`Add Second Row`:`Remove Second Row`}</div> */}
            </label>

            <div
              className={`buttonsWrapper ${parts.longue? ' longue ':''} ${parts.layoutBack?'active':''}`}
              onClick={this.toggleBackRow}>
                <div className="inner"></div>
            </div>

          </div>

          {!!parts.layoutBack && (
            <div className="title" style={{marginTop:-8, paddingTop:0}}>Choose Back Row Layout</div>
          )}

          <div style={{display:!!parts.layoutBack ?'block':'none'}} className={'buttonsWrapper' + (!parts.layoutBack ? ' disabled' : '')}>
            <div className="scrollWrapper">
              {layouts_back.map((layout) => (
                <div key={layout.node}
                  className={`button ${parts.layoutBack && layout.node === parts.layoutBack.node ? 'active' : ''}`}
                  onClick={() => this.changeLayout(layout, 2)}
                >
                  <div
                    className="image"
                    style={{
                      backgroundImage: `url(${layout.buttonImage})`,
                    }}
                  />
                  <div className="layoutName name">
                    <b>{layout.buttonName}</b> <br />
                    <span style={{ fontStyle: 'italic' }}>{layout.width}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

          </div>
        ),
      },
      4: {
        left: (
          <div className={`leftPanel panel ${((apiLoaded || goToStep1) && step === 4 ? ' ' : ' hidden')} ${props['className']}`}>
            <div className="leftPanelContainer panelContainer reportContainer">
              <div className="report">
                <div className="heading">YOU HAVE CHOSEN</div>
                {Object.keys(this.getProperties()).map(
                  (name) =>
                    this.getProperties()[name] && (
                      <>
                        <div className="prop">
                          <div className="propName">{name.split('_').join(' ').toUpperCase()}</div>
                          <div className="propValue">{this.getProperties()[name]}</div>
                        </div>
                        { name === 'price_per_seating_position' ? <p style={{marginTop: 10}}>
                          Wholesale discounts available to re-sellers. <a href="https://www.elitehts.com/elite-pro" target='_blank'>Become a re-seller (opens in new tab)</a>
                        </p>: null}
                      </>
                    )
                )}
              </div>

              <div className="submitForm onlyMobile" style={{marginTop:'2em'}}>
                <div className="headerTitle">Submit for Quote</div>
                <div className="question">
                  <p>
                    You have selected a custom configuration that requires a personalized quotation. Please complete the
                    form below to receive your detailed retail quote.
                  </p>
                  {/*<p>*/}
                  {/*  Please note that retail pricing starts at $2690 per chair.*/}
                  {/*</p>*/}
                  <p>
                    <strong>
                      Wholesale pricing available to home professionals including AV Installers, Interior Designers,
                      Home Builders and Design Firms.
                    </strong>
                  </p>
                  {/*<p>*/}
                  {/*You have selected a custom configuration which is hand made in Canada and comes with an industry*/}
                  {/*leading 20 Year Warranty. */}
                  {/*</p>*/}
                  <p>
                    Please allow 1 business day for price quotation. For immediate pricing requests, please call
                    our concierge/sales team at 604-575-8310 (8am to 4pm PST). International residents may also call
                    0141
                    445 4195 (8:30am to 4:30pm GMT/UTC)
                  </p>
                  {/*<p>*/}
                  {/*<strong>Wholesale pricing available to*/}
                  {/*registered home professionals including Theater Installers, Interior Designers, Home Builders and*/}
                  {/*Design Firms</strong>.*/}
                  {/*</p>*/}
                </div>

                <Button
                    className="button submitButton block"
                    wide
                    isLoading={emailIsSending}
                    onClick={(e) => {
                      e.preventDefault()

                      this.openPopup();
                    }}
                >
                  <a>Submit for Price Quote</a>
                </Button>

                <Button
                    className="button block"
                    wide
                    isLoading={emailIsSending}
                    onClick={(e) => {
                      e.preventDefault()

                      this.handlePrev();
                    }}
                  >
                    <i className="arrow left" />
                    <a>BACK</a>
                </Button>


              </div>

              <ArPreview
              ar={this.state.ar}
              url={this.state.url}
              error={this.state.error}
              pendingRequest={this.state.pendingRequest}
              step={this.state.step} json={this.setupJSON()}/>
            </div>
          </div>
        ),
        right: (
          <div  ref={el => this.rightPanel = el}
            className={`rightPanel panel submitPanel ${((apiLoaded || goToStep1) && step === 4 ? ' ' : ' hidden')} ${props['className']}`}
            style={{ backgroundColor: 'rgba(239,239,239,1)' }}
          >
            <div className="rightPanelContainer panelContainer">
              <div className="submitForm onlyDesktop">
                <div className="headerTitle">Submit for Quote</div>
                <div className="question">
                  <p>
                    You have selected a custom configuration that requires a personalized quotation. Please complete the
                    form below to receive your detailed retail quote.
                  </p>
                  {/*<p>*/}
                  {/*  Please note that retail pricing starts at $2690 per chair.*/}
                  {/*</p>*/}
                  <p>
                    <strong>
                      Wholesale pricing available to home professionals including AV Installers, Interior Designers,
                      Home Builders and Design Firms.
                    </strong>
                  </p>
                  {/*<p>*/}
                  {/*  You have selected a custom configuration which is hand made in Canada and comes with an industry*/}
                  {/*  leading 20 Year Warranty.*/}
                  {/*</p>*/}
                  <p>
                    Please allow 1 business day for price quotation. For immediate pricing requests, please call
                    our concierge/sales team at 604-575-8310 (8am to 4pm PST). International residents may also call
                    0141
                    445 4195 (8:30am to 4:30pm GMT/UTC)
                  </p>
                  {/*<p>*/}
                  {/*  <strong>Wholesale pricing available to*/}
                  {/*    registered home professionals including Theater Installers, Interior Designers, Home Builders and*/}
                  {/*    Design Firms.</strong>*/}
                  {/*</p>*/}
                </div>
                <Form isPopup={false} close={this.closePopup} close={this.closePopup} contextThis={this}
                      state={this.state} emailIsSending={emailIsSending} onSubmit={this.onSubmit}/>
              </div>
            </div>
          </div>
        ),
      },
    }
    return panels[stepN][side]
  }

  getStepHint = (step) => {
    const hints = {
      // 1: [
      //   'Welcome to the Elite HTS Chair Customizer',
      //   'As the manufacturer, we can customize your theater chair anyway you like.',
      //   'After you have made your selections, please click the NEXT STEP button to view additional options.',
      //   // 'In the last step, you will be able to see the personalized chair in your spacious room.',
      // ],
      3: [
        'Please select your configuration and quantity for each row.',
        '(For larger VIP Cinemas, or if you require more than 2 rows, please contact customer service)',
        'Custom configurations and arm widths available upon request.',
        'Since there are slight width variations for certain arm styles, please verify final dimensions with our sales team.'
        // 'In the last step, you will be able to see the personalized chair in your spacious room.',
      ],
    }

    return hints[step]
  }

  goToConfirmation() {
    // const { parts } = this.state;
    // if (window.history.pushState) {
    //   var newurl =
    //     window.location.protocol +
    //     "//" +
    //     window.location.host +
    //     window.location.pathname +
    //     this.generateQueryParams(parts) +
    //     "&step=confirmation";
    //   window.history.pushState({ path: newurl }, "", newurl);
    // }

    if(window.top){
      window.top.location.replace('https://elitehts.com/thank-you?chair-customizer=1')

    }else{
      window.location.replace('https://elitehts.com/thank-you?chair-customizer=1')

    }

    // this.setState({
    //   showConfirmationPage: true
    // });
  }

  onSubmit = (e) => {

    const { form } = this.state
    form.submitTime = performance.now()
    e.preventDefault()
    // regex for email
    const re = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (re.test(String(form.email).toLowerCase())) {
      console.log('fine, sending data')
      this.setState({ invalidEmail: false })
      const props = this.getProperties()
      const chairProps = Object.keys(props)
        .filter((k) => !!props[k])
        .map((p) => ({
          name: p
            .split('_')
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(' '),
          value: props[p],
        }))

      this.setState({
        emailIsSending: true,
      })
      Mailer.sendEmail({
          ...form,
          companyTypes: Object.keys(form.companyTypes).filter((k) => !!form.companyTypes[k]),
          additionalRequirements: Object.keys(form.additionalRequirements).filter(
            (k) => !!form.additionalRequirements[k]
          ),
          chairProps,
          // url: window.location ? window.location.origin + this.generateQueryParams(this.state.parts) : 'https://configurator.elitehts.com/build-your-theater-chair-frame/' + this.generateQueryParams(this.state.parts),
          url: 'https://elitehts.com/build-your-theater-chair/' + this.generateQueryParams(this.state.parts),
      }).then( response => {
        this.setState({
                emailIsSending: false,
                status: response.success ? 'success': 'error',
                message:
                response.success
                    ? 'Thank You! Your quotation request has been successfully submitted. Our current response time is less than 1 business day. For express service, please speak to our project managers at 1-604-575-8310 (8am to 4pm PST)'
                    : 'Something went wrong.',
        })
        if (response.success) {
          // toast.success(
          //   'Thank You! Your quotation request has been successfully submitted. Our current response time is less than 1 business day. For express service, please speak to our project managers at 1-604-575-8310 (8am to 4pm PST)',
          //   {
          //     position: 'top-center',
          //     autoClose: 7000,
          //     hideProgressBar: true,
          //     closeOnClick: false,
          //     pauseOnHover: true,
          //     draggable: false,
          //   }
          // )
          this.goToConfirmation()
        } else {
          toast.error('Something went wrong.', {
            position: 'top-center',
            autoClose: 7000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: false,
          })
        }
      })

      // sendEmail(
      //   {
      //     ...form,
      //     companyTypes: Object.keys(form.companyTypes).filter((k) => !!form.companyTypes[k]),
      //     additionalRequirements: Object.keys(form.additionalRequirements).filter(
      //       (k) => !!form.additionalRequirements[k]
      //     ),
      //     chairProps,
      //     // url: window.location ? window.location.href : null,
      //     url: 'https://elitehts.com/build-your-theater-chair/' + this.generateQueryParams(this.state.parts),
      //   },
      //   (msg, status) => {
      //     // console.log(msg)
      //     this.setState({
      //       emailIsSending: false,
      //       status,
      //       message:
      //         status === 'success'
      //           ? 'Thank You! Your quotation request has been successfully submitted. Our current response time is less than 1 business day. For express service, please speak to our project managers at 1-604-575-8310 (8am to 4pm PST)'
      //           : 'Something went wrong.',
      //     })
      //     if (status === 'success') {
      //       // toast.success(
      //       //   'Thank You! Your quotation request has been successfully submitted. Our current response time is less than 1 business day. For express service, please speak to our project managers at 1-604-575-8310 (8am to 4pm PST)',
      //       //   {
      //       //     position: 'top-center',
      //       //     autoClose: 7000,
      //       //     hideProgressBar: true,
      //       //     closeOnClick: false,
      //       //     pauseOnHover: true,
      //       //     draggable: false,
      //       //   }
      //       // )
      //       this.goToConfirmation()
      //     } else {
      //       toast.error('Something went wrong.', {
      //         position: 'top-center',
      //         autoClose: 7000,
      //         hideProgressBar: true,
      //         closeOnClick: false,
      //         pauseOnHover: true,
      //         draggable: false,
      //       })
      //     }
      //   }
      // )

    } else {
      console.log('Email check failed')
      this.setState({ invalidEmail: true })
    }

  }

  toggleModal = (show = !this.state.isModalOpen) => {
    if (show) {
      this.makeScreenshots()
    }
    this.setState({ isModalOpen: show })
  }

  makeScreenshots = () => {
    const { screenshots } = this.state
    const { width, height } = screenshots

    screenshots.inProcess = true
    screenshots.images = []

    this.setState({ screenshots }, () => {
      window.api.gotoAnnotation(window.api._getAnnotationByName('screenshot1').index)
      setTimeout(
        () =>
          window.api.getScreenShot(width, height, 'image/png', (err, res1) => {
            window.api.gotoAnnotation(window.api._getAnnotationByName('screenshot2').index)
            setTimeout(() => window.api.gotoAnnotation(window.api._getAnnotationByName('screenshot2').index), 1500)
            setTimeout(() => window.api.gotoAnnotation(window.api._getAnnotationByName('screenshot2').index), 2500)

            screenshots.images.push(res1)
            setTimeout(
              () =>
                window.api.getScreenShot(width, height, 'image/png', (err, res2) => {
                  screenshots.images.push(res2)
                  screenshots.inProcess = false
                  this.setState({ screenshots })
                }),
              4000
            )
          }),
        2000
      )

      window.api.getScreenShot(width, height, 'image/png')
    })
  }

  toggleRatios = () => {
    this.setState({
      isRatio50: !this.state.isRatio50,
    })
  }
  sketchfabModelId() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const sketchfabModelId = urlParams.get('sketchfabModelId');
    if(sketchfabModelId){
      return sketchfabModelId;
    }
    return 'd65afd8e4cc64e0ba5c15ecba6afddbe'; // new colors
    return '73942c88c8c44cbfa9735aa5ffd70578';
    // return '1546dd210b19405191aa140c1d023612';
  }

  render() {
    const {
      emailIsSending,
      apiLoaded,
      step,
      prevStep,
      loaderIsHidden,
      showHint,
      isModalOpen,
      screenshots,
      showConfirmationPage,
      isRatio50,
      goToStep1,
      isPopupVisible,
    } = this.state
    const { forExport } = this.props
    return (
      <React.Fragment>
        <Container
          className={
            (apiLoaded || goToStep1 ? "isLoaded" : "isLoading") +
            ` step${step} ${isRatio50 ? "" : " extendedRatio"}`
          }
        >
          {apiLoaded && (
            // layout preview
            <ModelFrame
              on2ndFrameLoaded={this.on2ndFrameLoaded}
              // uid="56c6362f468f465f93e51341b0a1739f"
              uid="710440f0cd3241d7ac5d66fccd96de01"
              hidden={step !== 3 && step !== 4}
              layoutFrame
              minimized={step === 3 || step === 4}
            />
          )}
          <ModelFrame
            onFrameLoaded={this.onFrameLoaded}
            uid={this.sketchfabModelId()}
            // uid="70955d7ee2ce4d82835265050133918c"
            // uid="bc7e6bead9d54e4c8420cb6ea0bbcf7d"
            // uid="512cf963fac9418b9a292062540db7ba"
            // uid="b65ec9de92e248329b7a5090dad52c8a"
            isTransparent={!!forExport}
            styles={{ opacity: apiLoaded ? 1 : 0 }}
          />
            <div className={'floatingSummary' + (step > 2 ? " floatingSummary__HideDesktop":"") }>
              <div className={'floatingSummary__ModelWrapper'}>
                <p className={'floatingSummary__Model'} style={{marginTop: 0}}>Model <span
                    className={'floatingSummary__Model__Name'}>{this.state.parts.arm.buttonName}{this.state.parts.seat.buttonName}</span>
                </p>

              </div>
              <div className={'floatingSummary__Details'}>
                <div className={'floatingSummary__DetailsTitle'}>Features</div>
                {this.getFeaturesText()}
              </div>
              <div className={'floatingSummary__Details'}>
                <div className={'floatingSummary__DetailsTitle'}>Options</div>
                {this.getModelProperties()}
              </div>
              <div></div>
              {/*<div className={'floatingSummary__PriceWrapper'}>*/}
              {/*  <p className={'floatingSummary__Price'}>*/}
              {/*    <span className={'floatingSummary__Price_Currency'}>USD</span> <span*/}
              {/*      className={'floatingSummary__Price_Price'}>{convertToUSD(this.getTotalPrice())}</span><span class="floatingSummary__Price_Currency"> MSRP</span> <br/>*/}
              {/*  </p>*/}
              {/*  <p className={'floatingSummary__Price_Description'}>per seating position</p>*/}
              {/*</div>*/}
              <div className={"floatingSummary__Model_DescriptionWrapper"+ (step > 2 ? " floatingSummary__Model_DescriptionWrapper_Hidden":"")}>
                <p className={'floatingSummary__Model_Description'}>
                  <b>
                    Wholesale discounts available for <br/>
                    registered Dealers and Designers
                  </b>
                </p>
                <p className={'floatingSummary__Model_Description'} style={{marginBottom: 0}}>
                  Are you a trade professional? <br/>
                  <a href="https://www.elitehts.com/elite-pro" target='_blank'>
                    <b>
                      Become a re-seller (opens in new tab)
                    </b>
                  </a>
                </p>
              </div>

            </div>
          {/* main loader */}
          {!apiLoaded && (
              <div className="loadingOveflow">
                <svg className="spinner" viewBox="0 0 50 50">
                  <circle
                      className="path"
                      cx="25"
                      cy="25"
                      r="20"
                      fill="none"
                      strokeWidth="5"
                  ></circle>
                </svg>
                <div className="loadingMessage">
                  Loading Custom Options
                  {/* <span>.</span>
                <span>.</span>
                <span>.</span> */}
                </div>
              </div>
          )}
          {/* main preloader */}
          {!loaderIsHidden && (
              <LoadingScreen
                  // isLoaded={false}
                  isLoaded={apiLoaded || goToStep1}
                  hideLoader={() => this.setState({loaderIsHidden: true})}
              />
          )}

          <div
              className={
                  "hintWindow" +
                  (showHint && !!this.getStepHint(step) ? "" : " closed") +
                  (step === 3 ? " blue" : " grey")
              }
              onClick={() =>
                  this.setState({
                    showHint: false,
                  })
              }
          >
            {/* <div className="close">x</div> */}
            {(
              this.getStepHint(step) ||
              (prevStep && this.getStepHint(prevStep)) ||
              []
            ).map((text, i) => (
              <span key={i}>
                <br />
                {text}
                <br />
              </span>
            ))}
          </div>
          <div
            className={
              `step-${step} ` +
              "contentWrapper" +
              (step !== 1 ? " disabled" : "")
            }
          >
            {this.getPanels(1, "left")}
            <div className="centalPanel" />
            {this.getPanels(1, "right")}
          </div>
          <div
            className={
              `step-${step} ` +
              "contentWrapper" +
              (step !== 2 ? " disabled" : "")
            }
          >
            {this.getPanels(2, "left")}
            <div className="centalPanel" />
            {this.getPanels(2, "right")}
          </div>
          <div
            className={
              `step-${step} ` +
              "contentWrapper block" +
              (step !== 3 ? " disabled" : "")
            }
          >
            {this.getPanels(3, "left")}
            <div className="centalPanel" />
            {this.getPanels(3, "right")}
          </div>
          <div
            ref={(el) => (this.contentWrapper = el)}
            className={
              `step-${step} ` +
              "contentWrapper" +
              (step !== 4 ? " disabled" : "")
            }
          >
            {this.getPanels(4, "left")}
            <div className="centalPanel" />
            {this.getPanels(4, "right", { className: "onlyDesktop" })}
          </div>
          <div className={`step-${step} onlyMobile mobileReport`}>
            {this.getPanels(4, "left")}
          </div>
          <div className="progressTabs">
            <div
              className={"tab" + (step === 1 ? " active" : "")}
              onClick={() => this.setState({ prevStep: step, step: 1 })}
            >
              <span className="notTablet">STEP 1.</span> Build Your Chair
            </div>
            <div className="split" />
            <div
              className={"tab" + (step === 2 ? " active" : "")}
              onClick={() => this.setState({ prevStep: step, step: 2 })}
            >
              <span className="notTablet">STEP 2.</span> Options
            </div>
            <div className="split" />
            <div
              className={"tab" + (step === 3 ? " active" : "")}
              onClick={() => this.setState({ prevStep: step, step: 3 })}
            >
              <span className="notTablet">STEP 3.</span> Layouts
            </div>
            <div className="split" />
            <div
              className={"tab" + (step === 4 ? " active" : "")}
              onClick={() => this.setState({ prevStep: step, step: 4 })}
            >
              <span className="notTablet">STEP 4.</span> Submit for Quotation
            </div>
          </div>
          <div className={`buttonsBlock step-${step}`}>
            <Button
              className="button back"
              onClick={step > 1 ? this.handlePrev : null}
              // style={step > 1 ? {} : { pointerEvents: 'none', opacity: 0 }}
            >
              <i className="arrow left" />
              <a>BACK</a>
            </Button>
            {forExport && (
              <Button className="button" onClick={() => this.toggleModal(true)}>
                <a>EXPORT</a>
              </Button>
            )}
            <Button
              className="button resize onlyMobile"
              onClick={() => this.toggleRatios()}
            >
              {isRatio50 && <a>⤓</a>}
              {!isRatio50 && <a>⤒</a>}
            </Button>
            <Button
              className="button next"
              onClick={step < 4 ? this.handleNext : null}
              // style={step < 4 ? {} : { visibility: 'hidden', opacity: 0 }}
            >
              <a>NEXT STEP</a>
              <i className="arrow right" />
            </Button>
          </div>
          {step === 4 && (
            <Button
              className="button submitButton onlyMobile"
              wide
              isLoading={emailIsSending}
              onClick={(e) => {
                e.preventDefault();
                if (this.submit) {
                  gaTrackSubmit();
                  this.submit.click();
                }
              }}
            >
              <a>Submit for Price Quote</a>
            </Button>
          )}
          <ReactTooltip
            place="top"
            type="light"
            effect="solid"
            globalEventOff="click"
          />

          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              display: isPopupVisible ? "block" : "none",
            }}
            className="ModalOverlay"
          >
            <div className="ModalOverlay__inner">
              <Form
                close={this.closePopup}
                contextThis={this}
                state={this.state}
                emailIsSending={emailIsSending}
                onSubmit={this.onSubmit}
              />
            </div>
          </div>
        </Container>

        <Modal
          title="Export Tool"
          isVisible={isModalOpen}
          closeModal={() => this.toggleModal(false)}
        >
          <ExportTool>
            <div className="wrapper">
              <div className="texts">
                <div className="label">Chair ID url:</div>
                <div className="text">
                  <div
                    className="prop"
                    style={{
                      maxWidth: "350px",
                      overflow: "auto",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <div className="propValue">
                      {window.location.protocol +
                        "//" +
                        window.location.host +
                        window.location.pathname +
                        this.generateQueryParams(this.state.parts, false)}
                    </div>
                  </div>
                </div>
                <div className="text">
                  {[
                    "model",
                    "material",
                    "color",
                    "stitching",
                    "piping",
                    "woodtrim",
                    "wood_finish",
                    "metal_finish",
                    "diamond_quilting",
                    "cupholder",
                  ].map(
                    (name) =>
                      this.getProperties()[name] && (
                        <div className="prop">
                          <div className="propName">
                            {name.split("_").join(" ").toUpperCase()}:
                          </div>
                          <div className="propValue">
                            {this.getProperties()[name]}
                          </div>
                        </div>
                      )
                  )}
                </div>
              </div>
              <div className="images">
                <div className="inputs">
                  <Input
                    label="Screenshots Width"
                    contextThis={this}
                    name="width"
                    parentObj="screenshots"
                  />
                  <Input
                    label="Screenshots Height"
                    contextThis={this}
                    name="height"
                    parentObj="screenshots"
                  />
                  <Button
                    className="button"
                    isLoading={screenshots.inProcess}
                    onClick={this.makeScreenshots}
                  >
                    <a>Get screenshots</a>
                  </Button>
                </div>
                <div className="screenshots">
                  {screenshots.images.map((img) => (
                    <img src={img} alt="" />
                  ))}
                </div>
              </div>
            </div>
          </ExportTool>
        </Modal>
        {/* {showConfirmationPage && (
          <ConfirmationPage
            goBack={() => this.setState({ showConfirmationPage: false })}
          />
        )} */}
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
      </React.Fragment>
    );
  }

  handlePrev = () => {
    const { step } = this.state
    // const newStep = step - 1
    const newStep = step - 1
    updateStepQuery(newStep)
    this.setState({ prevStep: step, step: newStep })
  }

  handleNext = () => {
    const { step } = this.state
    const newStep = step + 1
    gaTrackNext(newStep)
    updateStepQuery(newStep)
    this.setState({ prevStep: step, step: newStep })
  }
}

Configurator.propTypes = {}

export default Configurator
